import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "plan-cards-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Plan COBRA Details"),
  /*#__PURE__*/_createElementVNode("div", { class: "card-control plus" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "plus iatse-icon-plus" }),
    /*#__PURE__*/_createElementVNode("span", { class: "line" })
  ])
], -1)
const _hoisted_4 = { class: "plan-general-details card card-toggle" }
const _hoisted_5 = {
  key: 0,
  class: "plan-general-detail-container card"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-user-shield" })
], -1)
const _hoisted_7 = { class: "plan-general-detail" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", null, "Participant ID", -1)
const _hoisted_9 = { class: "plan-general-detail-container card" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-calendar-payment-loan" })
], -1)
const _hoisted_11 = { class: "plan-general-detail" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", null, "Name", -1)
const _hoisted_13 = { class: "plan-general-detail-container card" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-donate" })
], -1)
const _hoisted_15 = { class: "plan-general-detail" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h5", null, "Date of Birth", -1)
const _hoisted_17 = { class: "plan-general-detail-container card" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-money-check-edit" })
], -1)
const _hoisted_19 = { class: "plan-general-detail" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h5", null, "Gender", -1)
const _hoisted_21 = { class: "plan-general-detail-container card" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-legal" })
], -1)
const _hoisted_23 = { class: "plan-general-detail" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h5", null, "Address", -1)
const _hoisted_25 = { class: "plan-general-details card card-toggle" }
const _hoisted_26 = { class: "plan-general-detail-container card" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-time-quarter" })
], -1)
const _hoisted_28 = { class: "plan-general-detail" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, "Plan", -1)
const _hoisted_30 = { class: "plan-general-detail-container card" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-person-circle-xmark" })
], -1)
const _hoisted_32 = { class: "plan-general-detail" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Status ")
], -1)
const _hoisted_34 = { class: "plan-general-detail-container card" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-together-people" })
], -1)
const _hoisted_36 = { class: "plan-general-detail" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Event")
], -1)
const _hoisted_38 = { class: "plan-general-detail-container card" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-person-circle-xmark" })
], -1)
const _hoisted_40 = { class: "plan-general-detail" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "COBRA Effective")
], -1)
const _hoisted_42 = { class: "plan-general-detail-container card" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-hr-person" })
], -1)
const _hoisted_44 = { class: "plan-general-detail mr-10" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Event Date")
], -1)
const _hoisted_46 = { class: "plan-general-details card card-toggle" }
const _hoisted_47 = { class: "plan-general-detail-container card" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-time-quarter" })
], -1)
const _hoisted_49 = { class: "plan-general-detail" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, "Max Term Date", -1)
const _hoisted_51 = { class: "plan-general-detail-container card" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-person-circle-xmark" })
], -1)
const _hoisted_53 = { class: "plan-general-detail" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Months Entitled")
], -1)
const _hoisted_55 = { class: "plan-general-detail-container card" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-together-people" })
], -1)
const _hoisted_57 = { class: "plan-general-detail" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Months elapsed")
], -1)
const _hoisted_59 = { class: "plan-general-detail-container card" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "info-card__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-person-circle-xmark" })
], -1)
const _hoisted_61 = { class: "plan-general-detail" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail-info" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Months remaining")
], -1)
const _hoisted_63 = { class: "plan-summary__footer row w-100" }
const _hoisted_64 = { class: "col-12 col-md-4" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h4", null, "Other Coverages", -1)
const _hoisted_66 = { class: "account-actions" }
const _hoisted_67 = { class: "action-buttons" }
const _hoisted_68 = { class: "col-12 col-md-8" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h4", null, "Account Actions", -1)
const _hoisted_70 = { class: "action-buttons flex-md-row flex-column mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CobraPayments = _resolveComponent("CobraPayments")!
  const _component_OtherCoverages = _resolveComponent("OtherCoverages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        ($setup.dataLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Person.PersonID), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Person.Name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Person.DateOfBirth), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Person.Gender), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Person.Address), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Coverage?.Plan ?? 'N/A'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Coverage?.Status ?? 'N/A'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Coverage?.Event  ?? 'N/A'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Coverage?.EffectiveDate  ?? 'N/A'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Coverage?.EventDate ?? 'N/A'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _hoisted_48,
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Coverage?.ExpirationDate  ?? 'N/A'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _hoisted_54,
            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Coverage?.MonthsEntitled ?? 'N/A'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Coverage?.ElapsedMonths ?? 'N/A'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _hoisted_60,
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("h4", null, _toDisplayString($setup.planSummary.Coverage?.RemainingMonths ?? 'N/A'), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_CobraPayments, {
      cobraPayments: $setup.planSummary.CobraInvoices,
      showMore: true,
      title: $setup.title
    }, null, 8, ["cobraPayments", "title"]),
    _createElementVNode("div", _hoisted_63, [
      _createElementVNode("div", _hoisted_64, [
        _hoisted_65,
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createVNode(_component_OtherCoverages, {
              otherCoverages: $setup.planSummary.OtherCoverages
            }, null, 8, ["otherCoverages"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_68, [
        _hoisted_69,
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("a", {
            href: "",
            class: "btn btn-secondary plan-modal",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.openModal('add-beneficiary', 'My Beneficiary(ies)', 'plan-tables-striped beneficiary', null, null, null
                        )), ["prevent"]))
          }, " Beneficiary(ies) "),
          _createElementVNode("a", {
            href: "#",
            class: "btn btn-secondary btn-large plan-modal",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.openModal('claims', 'Claims', 'plan-upload plan-card-info plan-c-mrp-claims')), ["prevent"]))
          }, " Claims "),
          _createElementVNode("a", {
            href: "",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.openModal('request-card', 'Request for Insurance ID Card(s)', 'plan-upload plan-card-info plan-profile-update')), ["prevent"])),
            class: "btn btn-secondary plan-modal"
          }, "Request ID Card(s)"),
          _createElementVNode("a", {
            href: "",
            class: "btn btn-secondary btn-large plan-modal",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.openModal('dependents', 'My Dependents', null)), ["prevent"]))
          }, "My Dependents ")
        ])
      ])
    ])
  ]))
}